import TB from '@tiger/bridge';
import { useLogger } from '@tiger/logger';
import { useEffect } from 'react';
import APPStore from 'stores/APP';

/**
 * 设置当前页面为安全模式，此时用户截图、录屏时，APP会提示用户含有隐私信息
 */
export default function usePageSafeMode() {
    const logger = useLogger('hooks/usePageSafeMode');

    useEffect(() => {
        const { isTiger } = APPStore;

        if (isTiger) {
            TB.setPageSafeMode(true);
            logger.log('页面已开启安全隐私模式');
        }

        return () => {
            if (isTiger) {
                TB.setPageSafeMode(false);
                logger.log('页面已取消安全隐私模式');
            }
        };
    }, [logger]);
}
